import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL, WEIGHT_LOSS_EXAM, IV_THERAPY_EXAM } from '../constants';

function PrescriptionPaymentPage() {
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const requestId = queryParams.get('requestId');
  const type = queryParams.get('type');

  const [loadingPayment, setLoadingPayment] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getPaymentLink = async () => {
      try {
        setLoadingPayment(true);

        let response;

        if (type === WEIGHT_LOSS_EXAM) {
          response = await axios.post(
            `${BASE_URL}/payment/weightLoss/prescription`,
            {
              requestId,
            }
          );
        } else if (type === IV_THERAPY_EXAM) {
          response = await axios.post(
            `${BASE_URL}/payment/ivTherapy/prescription`,
            {
              requestId,
            }
          );
        }

        window.location.href = response.data.url;
      } catch (error) {
        console.error('Error sending request:', error);
        setError(
          error.response?.data?.error ||
            'Failed to process your request. Please try again later.'
        );
      } finally {
        setLoadingPayment(false);
      }
    };

    if (requestId) {
      getPaymentLink();
    }
  }, [requestId, type]);

  if (loadingPayment) {
    return (
      <div className='flex items-center justify-center h-screen bg-gray-100 text-gray-700 font-sans'>
        <div className='flex flex-col items-center'>
          <div className='loader'></div>
          <p className='mt-8 text-lg'>Redirecting to payment...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className='flex items-center justify-center h-screen bg-gray-100 text-gray-700 font-sans'>
        <div className='text-center p-6 bg-white rounded-lg shadow-lg'>
          <h2 className='text-2xl font-semibold text-red-600'>Error</h2>
          <p className='mt-4'>{error}</p>
          <button
            onClick={() => window.location.reload()}
            className='mt-6 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700'
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className='flex items-center justify-center h-screen bg-gray-100 text-gray-700 font-sans'>
      <p className='text-lg'>Redirecting to payment...</p>
    </div>
  );
}

export default PrescriptionPaymentPage;
